import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDeviceVideoSwitch } from '@/service/ys7';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  // 设备视频类开关状态
  deviceVideoSwitch: {
    data: {},
    query: {}
  }
};

// 查询设备视频类开关状态
export const fetchDeviceVideoSwitch = createAsyncThunk(
  'ys7VideoSwitch/fetchDeviceVideoSwitch',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getDeviceVideoSwitch(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取设备视频类开关状态失败');
    }
  }
);

const videoSwitchSlice = createSlice({
  name: 'ys7VideoSwitch',
  initialState: defaultState,
  reducers: {
    resetVideoSwitchState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      // fetchDeviceVideoSwitch
      .addCase(fetchDeviceVideoSwitch.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.deviceVideoSwitch.query = action.meta.arg || {};
      })
      .addCase(fetchDeviceVideoSwitch.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.deviceVideoSwitch.data = action.payload?.data?.data || action.payload?.data || {};
        state.deviceVideoSwitch.query = action.payload?.query || {};
      })
      .addCase(fetchDeviceVideoSwitch.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.deviceVideoSwitch.data = {};
      });
  }
});

export const { resetVideoSwitchState } = videoSwitchSlice.actions;
export default videoSwitchSlice.reducer;
